import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </Tag>
  );
};

export const GoldLine = ({ className = "" }) => (
  <motion.div
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
    className={`gold-line origin-left ${className}`}
  />
);

export const SectionHeading = ({ eyebrow, title, goldWord, align = "left" }) => (
  <div className={align === "center" ? "text-center" : ""}>
    {eyebrow && (
      <Reveal>
        <p className="eyebrow mb-5">{eyebrow}</p>
      </Reveal>
    )}
    <Reveal delay={0.1}>
      <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-[#F5F2EB]">
        {title} {goldWord && <span className="gold-gradient-text italic">{goldWord}</span>}
      </h2>
    </Reveal>
    <GoldLine className={`mt-8 w-24 ${align === "center" ? "mx-auto" : ""}`} />
  </div>
);
